import { rem as originalRem } from 'polished';

const defaultBaseFontSize = window.getComputedStyle(document.body).getPropertyValue('font-size').match(/\d+/);
const parsedDefaultBaseFontSize = defaultBaseFontSize && defaultBaseFontSize.length ? Number(defaultBaseFontSize[0]) : 16;

const rem = (pxVal: string | number): string => originalRem(pxVal, parsedDefaultBaseFontSize);

export { rem };

export default rem;
